import React, { useState, useEffect } from "react";
import {
  useMediaQuery,
  Box,
  TextField,
  Button,
  Typography,
  CardHeader,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  AvatarGroup,
  Stack,
  Avatar,
  Grid,
  IconButton,
  FormControl,
  FormControlLabel, Checkbox, Select, MenuItem,
  capitalize
} from "@mui/material";
import {
  setTemplateForView,
} from "../../Slices/templateslice";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Skeleton from '@mui/material/Skeleton';
import http from "../../utils/http-common";
import Like from '../../assets/planshare icons/like.png';
import Saved from '../../assets/planshare icons/download.png';
import AllCategory from '../../assets/planshare icons/All categories.png';
import Aerospace from '../../assets/planshare icons/Aerospace.png';
import Agriculture from '../../assets/planshare icons/Agriculture.png';
import Automobile from '../../assets/planshare icons/Automobile.png';
import Chemical from '../../assets/planshare icons/Chemical.png';
import Construction from '../../assets/planshare icons/Construction.png';
import cardbackground from "../../assets/landing_page/new/Frame 2095584531.svg";
import Finance from '../../assets/planshare icons/Finance.png';
import Healthcare from '../../assets/planshare icons/Healthcare.png';
import HeavyMachine from '../../assets/planshare icons/Heavy Machine.png';
import Mining from '../../assets/planshare icons/Mining.png';
import Nuclear from '../../assets/planshare icons/Nuclear.png';
import Oil from '../../assets/planshare icons/Oil & Gas.png';
import Pharmaceutical from '../../assets/planshare icons/Pharmaceutical.png';
import Power from '../../assets/planshare icons/Power & utility.png';
import Retail from '../../assets/planshare icons/Retail Supply chain.png';
import Telecom from '../../assets/planshare icons/Telecom.png';
import Ship from '../../assets/planshare icons/Ship building.png';
import Software from '../../assets/planshare icons/Software.png';
import Insurance from '../../assets/planshare icons/insurance.png';
import favoriteIcon from '../../assets/planshare icons/favourite-yellow.png';
import unfavoriteIcon from '../../assets/planshare icons/star_white.svg';
import Road from '../../assets/planshare icons/Road.png';
import Electronics from '../../assets/planshare icons/Electronics.png';
import FilterIcon from '../../assets/planshare icons/filter.png';
import { useDispatch } from "react-redux";
const SearchTemplatePage = ({
  drawerOpen,
  handleSearch,
  sortOption,
  filterTemplateSearch,
  filteredTemplate,
  showSearch,
  searchTerm,
  setShowSearch,
  setSortOption,
  categoriesData,
  categoriesFilter,
  setCategoriesFilter,
  selectedCategory,
  setSelectedCategory,
  setFilteredTemplate,
  showResult,
  setShowResult
}) => {

  const icon = {
    "All Category": <img src={AllCategory} alt="all" height={18} width={18} />, // General category icon
    "Aerospace": <img src={Aerospace} alt="aero" height={18} width={18} />,
    "Construction": <img src={Construction} alt="constr" height={18} width={18} />,
    "Pharmaceutical": <img src={Pharmaceutical} alt="pharma" height={18} width={18} />,
    "Oil & Gas": <img src={Oil} alt="oil" height={18} width={18} />, // You can use a more specific icon if available
    "Automobile": <img src={Automobile} alt="auto" height={18} width={18} />,
    "Power & utility": <img src={Power} alt="power" height={18} width={18} />,
    "Healthcare": <img src={Healthcare} alt="health" height={18} width={18} />,
    "Telecom": <img src={Telecom} alt="tele" height={18} width={18} />, // If available, replace with more specific tools icon
    "Finance": <img src={Finance} alt="finance" height={18} width={18} />,
    "Insurance": <img src={Insurance} alt="insur" height={18} width={18} />,
    "Road": <img src={Road} alt="insur" height={18} width={18} />,
    "Retail Supply chain": <img src={Retail} alt="retail" height={18} width={18} />,
    "Software": <img src={Software} alt="software" height={18} width={18} />,
    "Heavy Machine": <img src={HeavyMachine} alt="heavy" height={18} width={18} />,
    "Chemical": <img src={Chemical} alt="chemical" height={18} width={18} />,
    "Nuclear": <img src={Nuclear} alt="nuclear" height={18} width={18} />,
    "Electronics": <img src={Electronics} alt="nuclear" height={18} width={18} />,
    "Ship building": <img src={Ship} alt="ship" height={18} width={18} />,
    "Mining": <img src={Mining} alt="mine" height={18} width={18} />,
    "Agriculture": <img src={Agriculture} alt="agri" height={18} width={18} />,

  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    FetchAllTemplates();
  }, []);
  const [showAllState, setShowAllState] = useState({});
  const username = localStorage.getItem("user_name");
  const [filteredPlans, setFilteredPlans] = useState([]);
  const [allTemplateData, setAllTemplateData] = useState([]);
  const FetchAllTemplates = async () => {
    try {
      const response = await http.get(
        "/master_service/template/list/data"
      );
      const responseTemp = response.data;
      setAllTemplateData(responseTemp);
      setLoading(false);
    } catch (e) {
      console.error("error", e);
    }
  };

  const filterCategoryData = (category = selectedCategory, sort = sortOption) => {
    
    // Flatten the data into a single array
    const allData = [
      ...allTemplateData.My_Templates,
      ...allTemplateData.Favourite_Templates,
      ...allTemplateData.Top_Picks,
      ...allTemplateData.Featured_Templates,
    ];

    // Filter data by category and remove duplicates by plan_id
    const filteredData = allData
      .filter(item => item.category === category)
      .reduce((unique, current) => {
        const isDuplicate = unique.some(item => item.plan_id === current.plan_id);
        if (!isDuplicate) {
          unique.push(current);
        }
        return unique;
      }, []);

    setFilteredTemplate(filteredData);
  };

  const [dropdownOpen, setDropdownOpen] = useState(true);
  const [showFilter, setShowFilter] = useState(false);

  const handleCategoryClick = (category) => {
    if (category === "All Category") {
      setShowResult(true);
      setShowSearch(true);
      setCheckedCategory(categoriesFilter);
      const allCategories = [
        ...new Set(
          [
            ...allTemplateData.My_Templates,
            ...allTemplateData.Favourite_Templates,
            ...allTemplateData.Top_Picks,
            ...allTemplateData.Featured_Templates,
          ].map((item) => item.category)
        ),
      ];

      setTimeout(() => {
        const allData = [
          ...allTemplateData.My_Templates,
          ...allTemplateData.Favourite_Templates,
          ...allTemplateData.Top_Picks,
          ...allTemplateData.Featured_Templates,
        ];

        const filteredData = allData
          .filter((item) => allCategories.includes(item.category))
          .reduce((unique, current) => {
            const isDuplicate = unique.some(
              (item) => item.plan_id === current.plan_id
            );
            if (!isDuplicate) {
              unique.push(current);
            }
            return unique;
          }, []);

        setFilteredTemplate(filteredData);

        if (filteredData.length === 0) {
          console.error("No data found for All Category");
        }
      }, 0);

      return allCategories;
    } else {
      setShowSearch(true);
      setShowResult(true);
      setCheckedCategory((prev) =>
        prev.includes(category)
          ? prev.filter((cat) => cat !== category) // Remove if already selected
          : [...prev, category] // Add if not selected
      );
      setSelectedCategory((prev) =>
        prev.includes(category)
          ? prev.filter((cat) => cat !== category)
          : [...prev, category]
      );

      filterCategoryData(category);
    }
  };



  const handleView = (id) => {
    dispatch(setTemplateForView({ id, isView: true, table: false }));
    navigate("/home/viewtemplate");
  };

  const [showAll, setShowAll] = useState(false);

  const handleToggleFavorite = async (user_id, id, user_favorite) => {
    if (user_favorite === "yes") {
      const payload = {
        user_id: localStorage.getItem("user_id"),
        template_id: id,
        favorite_template: "no",
        top_pick: "no",
      };

      try {
        const response = await http.post(
          "/master_service/favt/top-pick/entry",
          payload
        );
        const responseData = response.data.record;
        toast.success("Template removed from favorites!");
        FetchAllTemplates();
        filterTemplateSearch();
        } catch (e) {
        console.error("Error updating unfavorite status:", e);
      }
    }
    else {
      const payload = {
        user_id: localStorage.getItem("user_id"),
        template_id: id,
        favorite_template: "yes",
        top_pick: "no",
      };

      try {
        const response = await http.post(
          "/master_service/favt/top-pick/entry",
          payload
        );
        const responseData = response.data.record;
        toast.success("Template added to favorites!");
        FetchAllTemplates();
        filterTemplateSearch();
        
      } catch (e) {
        // Check if the error response status is 400
        if (e.response && e.response.status === 400) {
          toast.error("Already selected as favorite");
        } else {
          // Log and handle other errors
          console.error("Error updating favorite status:", e);
          toast.error("An error occurred. Please try again later.");
        }
      }
    }

  };

  const [checkedCategory, setCheckedCategory] = useState([]);

  const handleCategoryToggle = (category) => {
    setCheckedCategory((prevCategories) => {
      if (!Array.isArray(prevCategories)) {
        console.error("checkedCategory is not an array:", prevCategories);
        return [category];
      }

      const updatedCategories = prevCategories.includes(category)
        ? prevCategories.filter((item) => item !== category) // Remove category if already included
        : [...prevCategories, category]; // Add new category

      // Perform filtering immediately based on the updated categories
      const allData = [
        ...allTemplateData.My_Templates,
        ...allTemplateData.Favourite_Templates,
        ...allTemplateData.Top_Picks,
        ...allTemplateData.Featured_Templates,
      ];

      const filteredData = allData
        .filter((item) => updatedCategories.includes(item.category))
        .reduce((unique, current) => {
          const isDuplicate = unique.some((item) => item.plan_id === current.plan_id);
          if (!isDuplicate) {
            unique.push(current);
          }
          return unique;
        }, []);

      setFilteredTemplate(filteredData);

      return updatedCategories;
    });
  };

  const filterPlans = (sort) => {
    const sorted = filteredTemplate.sort((a, b) => {
      if (sort === "New") {
        // Sort by the most recent `uploaded_time` date
        return new Date(b.uploaded_time) - new Date(a.uploaded_time);
      } else if (sort === "Popular") {
        // Sort by `top_pick` field (place "yes" at the top)
        if (a.top_pick === "yes" && b.top_pick !== "yes") return -1;
        if (b.top_pick === "yes" && a.top_pick !== "yes") return 1;
        return 0;
      } else if (sort === "Relevant") {
        // Alphabetical sorting by `plan_name`
        return a.plan_name.localeCompare(b.plan_name);
      }
      return 0; // Default (no specific sorting)
    });

    // Update the filtered templates
    setFilteredTemplate(sorted);
  };
  const handleSortChange = (option) => {
    setSortOption(option);
    filterPlans(option);
  };

  const renderTemplateSearch = () => (
    <Box sx={{ mb: 1 }}>
      <Box
        sx={{
          display: "grid", // Use grid layout
          gridTemplateColumns: dropdownOpen && showSearch ? "repeat(3, 1fr)" : "repeat(auto-fill, minmax(340px, 1fr))",
          gap: dropdownOpen && showSearch ? 1 : 2, // Add consistent spacing between cards
          justifyItems: "center", // Center items horizontally
          alignItems: "start", // Align items at the start vertically
        }}
      >
        {filteredTemplate.length > 0 ? (
          filteredTemplate.map((plan, index) => {
            return (
              <Card
                key={plan.id}
                variant="outlined"
                sx={{
                  minWidth: dropdownOpen && showSearch ? 275 : 350, // Reduce width when dropdownOpen and showSearch are true
                  maxWidth: "100%", // Ensure it doesn't exceed available space
                  borderRadius: 2,
                  boxShadow: 1,
                }}
              >
                <CardHeader sx={{ pb: 0, backgroundColor: "#E5EEFB66" }} />
                <CardContent sx={{ px: 1, py: 0 }}>
                  <Box
                    sx={{
                      position: "relative",
                      width: "100%",
                      height: 100
                    }}
                  >
                    <CardMedia
                      component="img"
                      image={cardbackground}
                      alt="Project Timeline"
                      sx={{
                        height: "100%",
                        width: "100%",
                        borderRadius: 1,
                        objectFit: "cover",
                        backgroundColor: "#0000001A",
                        transition: "background-color 0.3s ease",
                      }}
                    />
                    <IconButton
                      onClick={() =>
                        handleToggleFavorite(plan.user_id, plan.id, plan.user_favorite)
                      }
                      sx={{
                        position: "absolute",
                        top: 1,
                        right: 8,
                        width: 30,
                        height: 30,
                        backgroundColor: "gray",
                        borderRadius: 1,
                        "&:hover": {
                          backgroundColor: "gray",
                        },
                      }}
                    >
                      {plan.user_favorite === "yes" ? (
                        <img
                          src={favoriteIcon}
                          style={{ height: "20px", width: "20px" }}
                          alt="favorite"
                        />
                      ) : (
                        <img
                          src={unfavoriteIcon}
                          style={{ height: "20px", width: "20px" }}
                          alt="unfavorite"
                        />
                      )}
                    </IconButton>
                    <Button
                      variant="contained"
                      onClick={() => handleView(plan.id)}
                      sx={{
                        position: "absolute",
                        top: "60%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        backgroundColor: "transparent",
                        color: "#000",
                        fontFamily: "Inter, sans-serif",
                        fontSize: "10px",
                        fontWeight: 500,
                        textTransform: "none",
                        border: "1px solid #474747",
                        "&:hover": {
                          backgroundColor: "transparent",
                          border: "1px solid #474747",
                          color: "#000",
                        },
                      }}
                    >
                      View template
                    </Button>
                  </Box>
                  <Box
                    sx={{ borderBottom: "1px solid #ccc", backgroundColor: "#0000001A" }}
                  />
                  <Box
                    sx={{ display: "flex", justifyContent: "flex-start", flex: 1 }}
                  >
                    <Box>
                      <Typography
                        sx={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "10px",
                          fontWeight: 700,
                          textAlign: "left",
                          marginTop: "5px",
                        }}
                      >
                        {plan.plan_name}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "10px",
                          fontWeight: 500,
                          textAlign: "left",
                        }}
                      >
                        by {plan.created_by}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "flex-end", flex: 1, marginRight: "15px" }}></Box>
                    <Box sx={{ marginRight: "16px" }}>
                      <Typography
                        sx={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "10px",
                          fontWeight: 700,
                          lineHeight: "16px",
                          textAlign: "left",
                          marginTop: "5px",
                        }}
                      >
                        Cost
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "10px",
                          fontWeight: 500,
                          lineHeight: "16px",
                          textAlign: "right",
                        }}
                      >
                        {plan.cost == null || plan.cost === "" || isNaN(Number(plan.cost)) ? "Free" : `$${plan.cost}`}
                      </Typography>
                    </Box>
                    <Box sx={{ marginRight: "12px" }}>
                      <Typography
                        sx={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "10px",
                          fontWeight: 700,
                          lineHeight: "16px",
                          textAlign: "right",
                          marginTop: "5px",
                        }}
                      >
                        Likes
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "10px",
                          fontWeight: 500,
                          lineHeight: "16px",
                          textAlign: "right",
                        }}
                      >
                        {plan.likes ?? 0} <img src={Like} height="10px" width="10px" alt="like" />
                      </Typography>
                    </Box>
                    <Box sx={{ marginRight: "8px" }}>
                      <Typography
                        sx={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "10px",
                          fontWeight: 700,
                          lineHeight: "16px",
                          textAlign: "right",
                          marginTop: "5px",
                        }}
                      >
                        Saved
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "10px",
                          fontWeight: 500,
                          lineHeight: "16px",
                          textAlign: "right",
                        }}
                      >
                        {plan.top_pick_count ?? 0}  <img src={Saved} height="10px" width="10px" alt="saved" />
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            );
          })
        ) : (
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              marginTop: 15,
              marginLeft: dropdownOpen ? 30 : 80,
              fontSize: "20px",
              fontWeight: 500,
              textAlign: "center",
              color: "gray",
              width: "100%",
            }}
          >
            Template not found!
          </Typography>
        )}
      </Box>
    </Box>
  );


  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const isMediumScreen = useMediaQuery("(max-width:960px)");
  const isLargeScreen = useMediaQuery("(min-width:960px)");

  const renderTemplateDefault = (title, plans) => {
    // State to manage showAll for each title
    const cardGap = isSmallScreen ? 1 : isMediumScreen ? 2 : 3;
    // Function to toggle showAll for the specific title
    const toggleShowAll = (title) => {
      setShowAllState((prevState) => ({
        ...prevState,
        [title]: !prevState[title],
      }));
    };

    // Filter plans if the title is "Favourite Templates"
    const filteredPlans =
      title === "Favourite_Templates"
        ? plans.filter((plan) => plan.user_favorite) // Show only favorite plans
        : plans;

    // Determine which plans to display
    const isShowAll = showAllState[title] || false; // Default to false if not yet set
    const displayedPlans = isShowAll ? filteredPlans : filteredPlans.slice(0, 3);

    return (
      <Box key={title} sx={{ mb: 1 }}>
        {/* Plan Title and Toggle Button */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
            mb: 2,
          }}
        >
          <Typography sx={{ fontWeight: "bold", fontSize: "14px" }}>
            {title.replace(/_/g, " ")}
          </Typography>
          {filteredPlans.length > 3 && (
            <Button
              variant="outlined"
              onClick={() => toggleShowAll(title)}
              sx={{
                fontFamily: "Inter, sans-serif",
                fontSize: "14px",
                height: "25px",
                borderColor: "lightgray",
                textTransform: "none",
                color: "black",
                marginRight: "10px",
                "&:hover": {
                  borderColor: "lightgray",
                }
              }}
            >
              {isShowAll ? "Show Less" : "View All"}
            </Button>
          )}
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(3, minmax(340px, 1fr))", // Fixed 3-column layout
            gap: cardGap, // Spacing between cards
            justifyContent: "center", // Center content if less than 3 cards
            width: "100%"
          }}
        >
          {displayedPlans.map((plan) => (
            <Card
              key={plan.id}
              variant="outlined"
              sx={{
                flexShrink: 0,
                borderRadius: 2,
                boxShadow: 1,
                width: "100%",
              }}
            >
              {/* Card Content */}
              <CardHeader sx={{ pb: 0, backgroundColor: "#E5EEFB66" }} />
              <CardContent sx={{ px: 1, py: 0 }}>
                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    height: 100,
                  }}
                >
                  <CardMedia
                    component="img"
                    image={cardbackground}
                    alt="Project Timeline"
                    sx={{
                      height: "100%",
                      width: "100%",
                      borderRadius: 1,
                      objectFit: "cover",
                      backgroundColor: "#0000001A",
                      transition: "background-color 0.3s ease",
                    }}
                  />
                  <IconButton
                    onClick={() =>
                      handleToggleFavorite(
                        plan.user_id,
                        plan.id,
                        plan.user_favorite
                      )
                    }
                    sx={{
                      position: "absolute",
                      top: 1,
                      right: 8,
                      width: 30,
                      height: 30,
                      backgroundColor: "gray",
                      borderRadius: 1,
                      "&:hover": {
                        backgroundColor: "gray",
                      },
                    }}
                  >
                    {plan.user_favorite === "yes" ? (
                      <img
                        src={favoriteIcon}
                        style={{ height: "20px", width: "20px" }}
                        alt="favorite"
                      />
                    ) : (
                      <img
                        src={unfavoriteIcon}
                        style={{ height: "20px", width: "20px" }}
                        alt="unfavorite"
                      />
                    )}
                  </IconButton>
                  <Button
                    variant="contained"
                    onClick={() => {
                      handleView(plan.id);
                      }}
                    sx={{
                      position: "absolute",
                      top: "60%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      backgroundColor: "transparent",
                      color: "#000",
                      fontFamily: "Inter, sans-serif",
                      fontSize: "10px",
                      fontWeight: 500,
                      textTransform: "none",
                      border: "1px solid #474747",
                      "&:hover": {
                        backgroundColor: "transparent",
                        border: "1px solid #474747",
                        color: "#000",
                      },
                    }}
                  >
                    View template
                  </Button>
                </Box>
                <Box
                  sx={{
                    borderBottom: "1px solid #ccc",
                    backgroundColor: "#E5EEFB66",
                  }}
                />
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    backgroundColor: "transparent",
                  }}
                >
                  {/* Plan Name Section */}
                  <Box sx={{ display: "flex", justifyContent: "flex-start", flex: 1 }}>
                    <Box>
                      <Typography
                        sx={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "10px",
                          fontWeight: 700,
                          textAlign: "left",
                        }}
                      >
                        {plan.plan_name}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "10px",
                          fontWeight: 500,
                          textAlign: "left",
                        }}
                      >
                        by {plan.created_by}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Cost, Likes, and Saved Section */}
                  <Box sx={{ display: "flex", justifyContent: "flex-end", flex: 1, marginRight: "12px" }}>
                    <Box sx={{ marginLeft: "10px" }}>
                      <Typography
                        sx={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "10px",
                          fontWeight: 700,
                          lineHeight: "16px",
                          textAlign: "right",
                          marginTop: "5px",
                        }}
                      >
                        Cost
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "10px",
                          fontWeight: 500,
                          lineHeight: "16px",
                          textAlign: "right",
                        }}
                      >
                        {plan.cost == null || plan.cost === "" || isNaN(Number(plan.cost)) ? "Free" : `$${plan.cost}`}
                      </Typography>
                    </Box>

                    <Box sx={{ marginLeft: "10px" }}>
                      <Typography
                        sx={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "10px",
                          fontWeight: 700,
                          lineHeight: "16px",
                          textAlign: "right",
                          marginTop: "5px",
                        }}
                      >
                        Likes
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "10px",
                          fontWeight: 500,
                          lineHeight: "16px",
                          textAlign: "center",
                        }}
                      >
                        {plan.likes ?? 0} <img src={Like} height="10px" width="10px" alt="like" />
                      </Typography>
                    </Box>

                    <Box sx={{ marginLeft: "10px" }}>
                      <Typography
                        sx={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "10px",
                          fontWeight: 700,
                          lineHeight: "16px",
                          textAlign: "right",
                          marginTop: "5px",
                        }}
                      >
                        Saved
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          fontFamily: "Inter, sans-serif",
                          fontSize: "10px",
                          fontWeight: 500,
                          lineHeight: "16px",
                          textAlign: "center",
                        }}
                      >
                        {plan.top_pick_count ?? 0} <img src={Saved} height="10px" width="10px" alt="saved" />
                      </Typography>
                    </Box>
                  </Box>
                </Box>

              </CardContent>
            </Card>
          ))}
        </Box>
      </Box>
    );
  };




  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        alignItems: "flex-start",
        px: { xs: 1 },
        width: "100%", // Ensure it adapts to screen size
        paddingLeft: "0px"
      }}
    >
      {showSearch && (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="left"
          p={1} // Reduced padding
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "8px",
            fontWeight: 700,
            position: "relative",
            marginLeft: 1.2, // Reduced margin
            gap: 1, // Adds consistent spacing between child elements
          }}
        >
          {showResult && (
            <Typography>
              Result for "
              {searchTerm ||
                (checkedCategory.length >= 20
                  ? `All Category`
                  : checkedCategory.length > 1
                    ? `${checkedCategory.join(", ")}`
                    : `${checkedCategory}`)}"
            </Typography>
          )}
        </Box>
      )}

      {/* Skeleton Loader */}
      {loading ? (
        <Box sx={{
          mb: 2,
          width: "100%",
          overflowX: "auto"
        }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              fontFamily: "Inter, sans-serif",
              overflowX: "auto",
              gap: "10px",
              marginLeft: "20px",
              width: "100%",
              scrollbarWidth: "none", // For Firefox
              "&::-webkit-scrollbar": { display: "none" },
            }}
          >
            <Skeleton variant="text" width="30%" height={60} sx={{ borderRadius: '20px' }} />
            <Skeleton variant="text" width="30%" height={60} sx={{ borderRadius: '20px' }} />
            <Skeleton variant="text" width="30%" height={60} sx={{ borderRadius: '20px' }} />
            <Skeleton variant="text" width="30%" height={60} sx={{ borderRadius: '20px' }} />
            <Skeleton variant="text" width="30%" height={60} sx={{ borderRadius: '20px' }} />
            <Skeleton variant="text" width="30%" height={60} sx={{ borderRadius: '20px' }} />
            <Skeleton variant="text" width="30%" height={60} sx={{ borderRadius: '20px' }} />
            <Skeleton variant="text" width="30%" height={60} sx={{ borderRadius: '20px' }} />
          </Box>
          <Box
            sx={{
              display: 'flex',
              marginTop: "10px",
              marginLeft: "20px",
            }}
          >
            <Skeleton variant="text" width="30%" height={30} />
          </Box>
          <Box
            sx={{
              display: 'flex',
              overflowX: 'auto',
              gap: '20px',
              flexWrap: 'nowrap',
              width: '100%',
              maxWidth: '100vw',
              marginLeft: "20px",
              scrollbarWidth: 'none',
              '&::-webkit-scrollbar': { display: 'none' },
            }}
          >
            <Skeleton variant="rectangular" width={900} height={150} sx={{ borderRadius: '10px' }} />
            <Skeleton variant="rectangular" width={900} height={150} sx={{ borderRadius: '10px' }} />
            <Skeleton variant="rectangular" width={900} height={150} sx={{ borderRadius: '10px' }} />
          </Box>
          <Box
            sx={{
              display: 'flex',
              marginTop: "10px",
              marginLeft: "20px",
            }}
          >
            <Skeleton variant="text" width="30%" height={30} />
          </Box>
          <Box
            sx={{
              display: 'flex',
              overflowX: 'auto',
              gap: '20px',
              flexWrap: 'nowrap',
              width: '100%',
              maxWidth: '100vw',
              marginLeft: "20px",
              scrollbarWidth: 'none',
              '&::-webkit-scrollbar': { display: 'none' },
            }}
          >
            <Skeleton variant="rectangular" width={900} height={150} sx={{ borderRadius: '10px' }} />
            <Skeleton variant="rectangular" width={900} height={150} sx={{ borderRadius: '10px' }} />
            <Skeleton variant="rectangular" width={900} height={150} sx={{ borderRadius: '10px' }} />
          </Box>
        </Box>
      ) : (
        <>
          {/* Search and Categories */}
          {!showSearch && (<Box
            sx={{
              mb: 2,
              width: "100%",
              overflowX: "auto", // Allow scrolling for smaller screens
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                fontFamily: "Inter, sans-serif",
                overflowX: "auto",
                gap: "8.5px",
                marginLeft: "20px",
                width: "95%",
                scrollbarWidth: "none", // For Firefox
                "&::-webkit-scrollbar": { display: "none" },
              }}
            >
              {selectedCategory.map((category) => (
                <Button
                  key={category}
                  startIcon={icon[category]}
                  variant={selectedCategory === category ? "contained" : "outlined"}
                  onClick={() => handleCategoryClick(category)}
                  sx={{
                    flex: "0 0 auto",
                    textTransform: "none",
                    fontFamily: "Inter, sans-serif",
                    borderRadius: "20px",
                    fontSize: { xs: "12px", sm: "12px" },
                    color: selectedCategory === category ? "#FFF" : "black",
                    backgroundColor: selectedCategory === category ? "#FF2800" : "transparent",
                    borderColor: selectedCategory === category ? "transparent" : "#D3D3D3",
                    "&:hover": {
                      borderColor: "#D3D3D3",
                      backgroundColor: selectedCategory === category ? "#FF2800" : "#f5f5f5",
                    },
                  }}
                >
                  {category}
                </Button>
              ))}
            </Box>
          </Box>)}
          {/* Main Layout */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: { xs: 2, sm: 2 },
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                //alignItems: "center",
                justifyContent: dropdownOpen ? "flex-end" : "space-between"
              }}
            >
              {/* Filter Section */}
              {dropdownOpen && showSearch && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: { xs: "100%", sm: "200px" }, // Fixed width for filter
                    transition: "all 0.3s ease",
                    backgroundColor: "#f5f5f5",
                    p: 1,
                    marginTop: "20px",
                    marginLeft: 2,
                    borderRadius: "8px",
                    height: "auto", // Dynamically adjusts to content
                    maxHeight: "80vh", // Prevents excessive height
                  }}
                >

                  <button
                    style={{
                      fontFamily: "Inter, sans-serif",
                      backgroundColor: "#FF2800",
                      color: "white",
                      border: "none",
                      padding: "4px",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      window.location.reload();
                    }}
                  >
                    Back
                  </button>
                  <Button
                    onClick={() => setDropdownOpen(false)} // Close the dropdown
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      textTransform: "capitalize",
                      color: "black",
                      fontWeight: "700",
                      fontSize: { xs: "10px", sm: "14px" },
                      marginBottom: "8px",
                    }}
                  >
                    <img
                      src={FilterIcon}
                      style={{ height: "18px", width: "18px", marginRight: "8px" }}
                      alt="filtericon"
                    />
                    Hide Filter
                  </Button>
                  <Button
                    onClick={() => {
                      setSelectedCategory([]);
                      setFilteredTemplate([]);
                      setCheckedCategory([]);
                    }}
                    sx={{
                      textTransform: "capitalize",
                      color: "white",
                      backgroundColor: "#FF2800",
                      "&:hover": {
                        backgroundColor: "#FF2800",
                      },
                      fontSize: { xs: "8px", sm: "12px" },
                    }}
                  >
                    Clear All
                  </Button>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "bold",
                      fontSize: { xs: "10px", sm: "14px" },
                      marginTop: "8px",
                    }}
                  >
                    Category
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      height: "auto", // Adjusts dynamically to the list content
                      overflowY: "auto", // Enables scrolling if needed
                      maxHeight: "calc(100vh - 200px)", // Prevents excessive height
                    }}
                  >
                    {categoriesFilter.map((category) => (
                      <FormControlLabel
                        key={category}
                        control={
                          <Checkbox
                            sx={{
                              "&.Mui-checked": {
                                color: "var(--Primary-Color, #FF2800)",
                              },
                            }}
                            checked={
                              checkedCategory.includes(category) ||
                              (showResult && 
                               searchTerm && 
                               (category.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                filteredTemplate.some(template => 
                                  template.category.toLowerCase() === category.toLowerCase() &&
                                  (template.plan_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                   template.category.toLowerCase().includes(searchTerm.toLowerCase()))
                                ))
                              )
                            }
                            onChange={() => handleCategoryToggle(category)}
                          />
                        }
                        label={category}
                        sx={{
                          ".MuiTypography-root": {
                            fontSize: { xs: "10px", sm: "12px" },
                          },
                          marginBottom: 0,
                        }}
                      />
                    ))}
                  </Box>
                </Box>
              )}

            </Box>
            {/* Plans Section */}
            <Box
              sx={{
                flex: 1,
                width: dropdownOpen ? "calc(100% - 170px)" : "100%",
                display: "flex",
                flexDirection: "column",
                gap: "14px",
                transition: "all 0.3s ease",
              }}
            >
              {/* Filter Toggle and Sort Row */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between"
                }}
              >
                {!dropdownOpen && showSearch && (
                  <Button
                    onClick={() => setDropdownOpen(true)} // Open the dropdown
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      textTransform: "capitalize",
                      color: "black",
                      fontWeight: "700",
                      fontSize: { xs: "10px", sm: "14px" },
                    }}
                  >
                    <img
                      src={FilterIcon}
                      style={{ height: "18px", width: "18px", marginRight: "8px" }}
                      alt="filtericon"
                    />
                    Show Filter
                  </Button>
                )}
                {dropdownOpen && showSearch && (
                  <Button
                    onClick={() => setDropdownOpen(true)} // Open the dropdown
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      textTransform: "capitalize",
                      color: "black",
                      fontWeight: "700",
                      fontSize: { xs: "10px", sm: "14px" },
                    }}
                  />

                )}
                {!dropdownOpen && showSearch && (<FormControl sx={{ minWidth: "100px", display: "flex", marginRight: 2, justifyContent: "flex-end" }}>
                  <Select
                    value={sortOption || "Relevant"} // Set default value to "Relevant"
                    onChange={(e) => handleSortChange(e.target.value)}
                    sx={{
                      fontSize: { xs: "12px", sm: "14px" },
                      height: "25px",
                    }}
                  >
                    <MenuItem style={{ fontSize: "14px" }} value="Relevant">
                      Relevant
                    </MenuItem>
                    {["Popular", "New"].map((option) => (
                      <MenuItem style={{ fontSize: "14px" }} key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>)}
                {dropdownOpen && showSearch && (<FormControl sx={{ minWidth: "100px", marginRight: 2, display: "flex", justifyContent: "flex-end" }}>
                  <Select
                    value={sortOption || "Relevant"} // Set default value to "Relevant"
                    onChange={(e) => handleSortChange(e.target.value)}
                    sx={{
                      fontSize: { xs: "12px", sm: "14px" },
                      height: "25px",
                    }}
                  >
                    <MenuItem style={{ fontSize: "14px" }} value="Relevant">
                      Relevant
                    </MenuItem>
                    {["Popular", "New"].map((option) => (
                      <MenuItem style={{ fontSize: "14px" }} key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>)}
              </Box>

              {/* Render Plans */}
              {!showSearch &&
                Object.entries(allTemplateData).map(([key, plans]) =>
                  plans.length > 0 ? renderTemplateDefault(key, plans) : null
                )}
              {showSearch && renderTemplateSearch()}
            </Box>
          </Box>

        </>
      )}
    </Box>
  );
};

export default SearchTemplatePage;
